import { Chip, Tooltip } from "@mui/material";
import styles from "./SelectionChip.styles";

type TChipBase = {
  label: string;
};

type TSelectionChipProps<TChip extends TChipBase> = {
  chip: TChip;
  onRemove?: (chip: TChip) => void;
};

const SelectionChip = <TChip extends TChipBase>({
  chip,
  onRemove,
}: TSelectionChipProps<TChip>) => {
  const computedStyle = {
    ...styles.chip,
    ...(!onRemove && styles.unremovableChip),
  };

  return (
    <Tooltip placement="right" title={chip.label}>
      <Chip
        size="small"
        label={chip.label}
        sx={computedStyle}
        onDelete={onRemove ? () => onRemove(chip) : undefined}
      />
    </Tooltip>
  );
};

export default SelectionChip;
